"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteButton = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const useStyles = (0, core_1.makeStyles)(() => ({
    root: {
        background: '#FFF !important',
        fontWeight: 500,
        fontSize: 14,
        letterSpacing: 1.25,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        boxShadow: ({ disabled }) => disabled ? 'none' : 'rgba(0, 0, 0, 0.4)',
        color: ({ disabled }) => (disabled ? '#BDBDBD' : '#090C10'),
        '& svg': {
            color: ({ disabled }) => disabled ? '#BDBDBD' : '#090C10'
        }
    }
}));
const WhiteButton = (_a) => {
    var { children, disabled } = _a, props = __rest(_a, ["children", "disabled"]);
    const classes = useStyles({ disabled });
    return (react_1.default.createElement(core_1.Button, Object.assign({}, props, { className: classes.root, color: "default" }), children));
};
exports.WhiteButton = WhiteButton;
//# sourceMappingURL=white-button.js.map